import React, { forwardRef } from 'react';

import { FloatingFocusManager, FloatingPortal, useMergeRefs } from '@floating-ui/react';

import { type ContentProps } from '@pkg/components';
import { usePopoverContext } from '@pkg/components/Elements/Tooltip/hooks';
import { Content, TooltipBorder, TooltipWrapper } from '@pkg/components/Elements/Tooltip/styles';

export const PopoverContent = forwardRef<HTMLDivElement, ContentProps>(function PopoverContent(props, propRef) {
    const { context: floatingContext, ...rest } = usePopoverContext();
    const ref = useMergeRefs([rest.refs.setFloating, propRef]);
    if (!floatingContext.open) return null;
    return (
        <FloatingPortal>
            <FloatingFocusManager context={floatingContext} modal={rest.modal}>
                <TooltipWrapper
                    ref={ref}
                    style={{
                        ...rest.floatingStyles,
                    }}
                    aria-labelledby={rest.labelId}
                    aria-describedby={rest.descriptionId}
                    {...rest.getFloatingProps(props)}
                >
                    <TooltipBorder $variant={props.variant}>
                        <Content $variant={props.variant} $alignment={props.alignment}>
                            {props.children}
                        </Content>
                    </TooltipBorder>
                </TooltipWrapper>
            </FloatingFocusManager>
        </FloatingPortal>
    );
});
